import axios from 'axios'

export default function (value, { attribute, collection, id } = {}) {
  return axios.post(`/${collection}/validate/${attribute}`, { value, id }).then(response => {
    return {
      valid: response.data.valid,
    }
  })
}



// WEBPACK FOOTER //
// ./src/config/validations/unique.js